module.exports = __webpack_public_path__ + "static/media/imixm2mprofessional.b7fed655.png";